import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'

let environment = process.env.REACT_SENTRY_ENVIRONMENT || 'local'
let build_timestamp = process.env.REACT_APP_BUILDTIME || 'local'
let sentryDsn = process.env.REACT_APP_SENTRY_DSN

if (environment !== 'local' && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: environment,
    release: build_timestamp,
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 0.2,

    // Overwrite the defaults to ensure no trace headers are sent
    tracePropagationTargets: [],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })

  console.log('[Sentry] Initialized with environment:', environment)
}

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-undef
  window.addEventListener('error', (event) => {
    if (environment !== 'local' && sentryDsn) {
      const eventId = Sentry.captureException(event.error || event.message, {
        contexts: {
          error_event: {
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
          },
        },
      })

      if (process.env.NODE_ENV === 'development') {
        console.error(
          '[Global Error Handler] Reported to Sentry:',
          eventId,
          event.error
        )
      }
    } else if (process.env.NODE_ENV === 'development') {
      console.error('[Global Error Handler] (Sentry disabled):', event.error)
    }
  })

  //eslint-disable-next-line no-undef
  window.addEventListener('unhandledrejection', (event) => {
    if (environment !== 'local' && sentryDsn) {
      const eventId = Sentry.captureException(event.reason, {
        contexts: {
          promise: {
            rejection_reason: String(event.reason),
          },
        },
      })

      if (process.env.NODE_ENV === 'development') {
        console.error(
          '[Unhandled Rejection] Reported to Sentry:',
          eventId,
          event.reason
        )
      }
    } else if (process.env.NODE_ENV === 'development') {
      console.error('[Unhandled Rejection] (Sentry disabled):', event.reason)
    }
  })
}
